import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { closeCreativePreviewPopup } from '../../actions/bannerCreativePreviewPopup';
import { BannerTypesPopup, BannerTypesPopupProps } from '../../components/BannerTypesPopup/BannerTypesPopup';
import { selectGridBannerTypesData } from '../../selectors/grid/grid';
import { PreviewPopupVisibleType } from '../../typings/bannerCreativePreviewPopupState';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type StateProps = TStateProps<BannerTypesPopupProps>;

type DispatchProps = TDispatchProps<BannerTypesPopupProps>;

const BannerTypesPopupWrapper = (props: BannerTypesPopupProps) => {
    if (props.data && props.isVisible) {
        return <BannerTypesPopup {...props} />;
    }

    return null;
};

const mapStateToProps = (state: State): StateProps => {
    const { previewPopupVisibleType, creativeUrl, id } = state.bannerCreativePreviewPopup;
    const isVisible = previewPopupVisibleType === PreviewPopupVisibleType.bannerPreview;

    return {
        isVisible,
        data: selectGridBannerTypesData(state),
        bannerId: id,
        videoUrl: creativeUrl
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onCancel: () => dispatch(closeCreativePreviewPopup())
    };
};

export const BannerTypesPopupContainer = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(BannerTypesPopupWrapper);
